export const environment = {
  production: true,
  AUTHPORTAL_API_URL: "https://accounts.rinknet.com/api/",
  CONNECT_API_URL: 'https://app.1rink.com/',
  ONESIGNAL_APP_ID: "d551f2b9-7ee8-43df-8f92-548f0605eda6",
  CONNECT_DOMAIN: "https://app.1rink.com/#/",
  DEFUALT_APP_ID: "com.rinknet.rinknetconnect",
  ANDROID_DEFAULT_APP_ID: "com.rinknet.connect",
  IMAGE_TYPE: 1,
  VIDEO_TYPE: 2,
  DOCUMENT_TYPE: 3,
  APP_STORE_URL: "https://apps.apple.com/ca/app/rinknet-connect/id6448459748",
  PLAY_STORE_URL: "https://play.google.com/store/apps/details?id=com.rinknet.connect"
};
